import { render, staticRenderFns } from "./invite-customer.vue?vue&type=template&id=16c46c16&scoped=true"
import script from "./invite-customer.vue?vue&type=script&lang=js"
export * from "./invite-customer.vue?vue&type=script&lang=js"
import style0 from "./invite-customer.vue?vue&type=style&index=0&id=16c46c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c46c16",
  null
  
)

export default component.exports